import { create } from 'zustand'

export interface AlerteState {
  contracteExpiraAzi: number
  contracteExpirate: number
  facturiScadente: number
  clientiCiExpirate: number
  contracteCuPenalitati: number
  cadreCuExpirareApropiata: number
  drafturiAbandonateAproapeDeExpirare: number
  [key: string]: number
}

interface AlertsState {
  alerte: AlerteState | null
  lastFetch: number
  setAlerte: (a: AlerteState) => void
}

export const useAlertsStore = create<AlertsState>((set) => ({
  alerte: null,
  lastFetch: 0,
  setAlerte: (a) => set({ alerte: a, lastFetch: Date.now() }),
}))
